export default {"src":"/_next/static/media/realEstateLogo2.a3ee78a7.svg","height":42,"width":213,"blurWidth":0,"blurHeight":0};